import { LoadingButton } from "@mui/lab";
import { Box, Button, Checkbox, Icon, List, ListItem, ListItemIcon, ListItemText, Modal, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { downloadAndRenameFile, getFileNameFromLink } from "@/utils/allUtils";
import { useLiquidarCarritoMutation, useLiquidarInformesMutation, useLiquidarInformesPorUsuarioMutation } from "../../redux/api/informeApi";
import { ICarrito, IInforme } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";
import MyToastShow from "../Layout/MyToast";
import { obtenerNombreInforme } from "@/utils/informeUtils";
import { IUser } from "@/redux/models";
import EnvioProgramado from "./EnvioProgramado";

type ModalLiquidarUsuarioInformeProps = {
    open: boolean;
    onCancel: () => void;
    informes: IInforme[];
    carrito?: ICarrito;
    user?: IUser;
    onInformesLiquidados: (carritoActualizado: ICarrito) => void;
};
const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    boxShadow: 24,
    p: 4,
};

export type LiquidarInformesArgs = {
    listaDevuelta: number[];
    bool: boolean;
    fecha?: Date;
};

const ModalLiquidarUsuarioInforme = ({
    informes,
    carrito,
    open,
    onCancel,
    onInformesLiquidados,
}: ModalLiquidarUsuarioInformeProps) => {
    const darkMode = useAppSelector((state) => state.theme.darkTheme);
    const [link, setLink] = useState("");

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
    const boxWidth = isMobile ? "100%" : "40rem";



    const [liquidarInformes] = useLiquidarInformesPorUsuarioMutation();
    const [loading, setLoading] = useState(false);
    const [IvaChecked, setIvaChecked] = useState(false);
    const [selectFecha, setSelectFecha] = useState<Date | undefined>();

    const handleLiquidar = () => {
        let liquidarInformesArgs: LiquidarInformesArgs = {
            listaDevuelta: informes.map((informe) => informe.id),
            bool: IvaChecked,
            fecha: selectFecha
        };


        setLoading(true);
        liquidarInformes(liquidarInformesArgs).unwrap()
            .then(({ message, data, status }: any) => {
                setLoading(false)
                MyToastShow({ message, type: status })
                setLink(data);
            })
            .catch((err) => {
                setLoading(false);
                console.error("Error al liquidar informes:", err);
                MyToastShow({ message: "Error al liquidar informes", type: "error" });
            });
    }

    const handleCheck = (event: any) => {
        setIvaChecked(event.target.checked);
    };

    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`liquidar-informes`}
            sx={{
                width: "100%",
            }}
        >
            <Box
                sx={(theme) => ({
                    ...style,
                    width: boxWidth,
                    overflow: "auto",
                    maxHeight: "100%",
                    bgcolor: darkMode ? "#232323" : "#fff",
                })}
                aria-label={`liquidar-container-informes`}
            >
                {/* @ts-ignore */}
                {informes[0] && <Typography variant="h5" textAlign='center'>Liquidar Informes del usuario {informes[0].usuario.id} {informes[0].usuario?.nombre} {informes[0].usuario?.email}</Typography>}                <List sx={{ width: "100%", mt: 2 }}>
                    {informes.map((informe) => (
                        <ListItem >
                            <ListItemIcon>
                                <Icon>description</Icon>
                            </ListItemIcon>
                            <ListItemText
                                primary={obtenerNombreInforme(informe)}
                            />
                        </ListItem>
                    ))}
                </List>
                <Checkbox
                    checked={IvaChecked}
                    onChange={handleCheck}
                    inputProps={{ 'aria-label': 'Checkbox' }}
                />
                Liquidar con IVA

                <EnvioProgramado onChange={setSelectFecha} value={selectFecha} />


                {link && <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ ml: 1 }}
                        onClick={() => window.open(link, "_blank")}
                    >

                        Descargar liquidación
                    </Button>
                </Box>}


                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        color="error"
                        onClick={() => handleLiquidar()}
                    >

                        Liquidar
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ ml: 1 }}
                        onClick={() => onCancel()}
                    >

                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalLiquidarUsuarioInforme;
